/* eslint-disable no-else-return */
/* eslint-disable no-unreachable */
/* eslint-disable no-restricted-syntax */
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { Button, Form, message } from "antd";
import React, { useContext, useEffect, useState } from "react";
import {
  CREATE_LEAD_OPPORTUNITY,
  UPDATE_LEAD_OPPORTUNITY,
  CREATE_LEAD_VEHICLE_OF_INTEREST,
  UPDATE_LEAD_VEHICLE_OF_INTEREST,
} from "../../graphql/mutation";
import { sanitizeVehiclesForMutation, toMutationInput } from "./vehicleModal/utils/vehiclePayload";
import { checkAccessPermission, closeDialog } from "../../library/helpers";
import LeadOpportunityInformationForm from "./leadOpportunityInformationForm";
import { GET_LEAD_OPPORTUNITIES_BY_ID, GET_LEAD_SOURCES_NEW } from "../../graphql/query";
import { UserContext } from "../../amplify/authenticator-provider";
import { getParentIds } from "../../library/utils";
import { AccessPermissionAction } from "../../library/constants";

export default function OpportunityFormWrapper({
  mode,
  lead,
  getLeads = () => {},
  close,
  showCancel,
  form,
  updateLeadOpportunity,
  updateLeadOpportunityLoader,
  createLeadOpportunity,
  createLeadOpportunityLoader,
  refetch = () => {},
  refetchLeads = () => {},
  onVehiclePersisted = () => {},
  settings: settingsProp,
  // Active root opp_type tab from the activity center — forwarded into
  // ``LeadOpportunityInformationForm`` so the opp-type cascader filters
  // to the user's permitted roots and defaults to this active root in
  // ADD mode.
  selectedOppTypeId,
}) {
  const { user } = useContext(UserContext);
  const [leadData, setleadData] = useState({ leadOpportunityUsers: [], vehiclesOfInterest: [] });
  const [selectedOpportunity, setselectedOpportunity] = useState({
    leadOpportunityUsers: [],
    vehiclesOfInterest: [],
  });
  const [getLeadOpportunities] = useLazyQuery(GET_LEAD_OPPORTUNITIES_BY_ID);
  const [createLeadVehicleOfInterest] = useMutation(CREATE_LEAD_VEHICLE_OF_INTEREST);
  const [updateLeadVehicleOfInterest] = useMutation(UPDATE_LEAD_VEHICLE_OF_INTEREST);
  const [newOpportunity, setnewOpportunity] = useState(false);
  const [leadSources, setleadSources] = useState([]);
  const { loading: leadSourcesLoader } = useQuery(GET_LEAD_SOURCES_NEW, {
    fetchPolicy: "cache-first",
    variables: {
      companyId: user.company.id,
      // locationIds: sessionStorage.getItem("currentLocationId").split(","),
    },
    onCompleted: res => {
      setleadSources(res.getLeadSourcesNew);
    },
  });
  const handleSave = async value => {
    if (mode === "EDIT" && !newOpportunity) {
      const payload = {
        ...selectedOpportunity,
        leadOpportunityUsers: selectedOpportunity.leadOpportunityUsers.map(item => ({
          id: item.id,
          userId: item.userId,
          userTypeId: item.userTypeId,
        })),
        locationId: value.location,
        leadOpportunityId: +selectedOpportunity.id,
        vehicleOfInterests: sanitizeVehiclesForMutation(selectedOpportunity.vehiclesOfInterest),
        name: selectedOpportunity.opportunityName || selectedOpportunity.name,
        departmentId: value.departmentId || null,
      };
      const res = await updateLeadOpportunity({
        variables: {
          ...payload,
        },
      });
      if (res?.data?.updateLeadOpportunity?.statusCode === 200) {
        closeDialog("leadOpportunityFormDialog");
        refetch();
        refetchLeads();
        getLeads();
        message.success(res?.data?.updateLeadOpportunity?.message);
        close();
      } else {
        // CRM-sourced vehicles (e.g. DealerSocket) can't be deleted from EAI; the
        // backend rejects the update with a generic error. When the failed save
        // included a vehicle deletion, surface an actionable message instead.
        const attemptedVehicleDeletion = selectedOpportunity.vehiclesOfInterest?.some(
          vehicle => vehicle?.id && vehicle?.isDeleted
        );
        message.error(
          attemptedVehicleDeletion
            ? "Cannot delete vehicle. This vehicle was added from the CRM and must be removed there first."
            : res?.data?.updateLeadOpportunity?.message
        );
      }
    } else {
      let payload = {};
      if (newOpportunity) {
        payload = {
          leadId: lead.id,
          ...selectedOpportunity,
          name: selectedOpportunity.opportunityName,
          locationId: value.location,
          vehicleOfInterests: sanitizeVehiclesForMutation(selectedOpportunity.vehiclesOfInterest),
          departmentId: value.departmentId || null,
        };
      } else {
        payload = {
          leadId: lead.id,
          ...leadData,
          leadOpportunityUsers: leadData.leadOpportunityUsers.map(item => ({
            id: item.id,
            userId: item.userId,
            userTypeId: item.userTypeId,
          })),
          locationId: value.location,
          vehicleOfInterests: sanitizeVehiclesForMutation(leadData.vehiclesOfInterest),
          name: leadData.opportunityName || "",
          departmentId: value.departmentId || null,
        };
      }
      const res = await createLeadOpportunity({
        variables: {
          ...payload,
        },
      });
      if (res.data.createLeadOpportunity.statusCode === 200) {
        message.success(res.data.createLeadOpportunity.message);
        // closeDialog("leadOpportunityFormDialog");
        refetch();
        refetchLeads();
        getLeads();
        close();
      } else {
        message.error(res.data.createLeadOpportunity.message);
      }
    }
  };
  useEffect(() => {
    if (mode === "EDIT") {
      setselectedOpportunity(lead);
      const vehicleObj = {};
      for (let index = 0; index < lead?.vehiclesOfInterest?.length; index++) {
        const element = lead.vehiclesOfInterest[index];
        for (const key of Object.keys(element)) {
          vehicleObj[`vehiclesOfInterest[${index}].${key}`] = element[key];
        }
      }
      const ownerObj = {};
      for (let index = 0; index < lead?.leadOpportunityUsers?.length; index++) {
        const element = lead.leadOpportunityUsers[index];
        ownerObj[`leadOpportunityUsers-${element.id}`] = +element.userId;
      }
      form.setFieldsValue({
        ...lead,
        location: lead?.location?.id,
        opportunityName: lead?.name,
        opportunityTypeId: +lead?.opportunityTypeId,
        opportunityStatusId: +lead?.opportunityStatusId,
        // ...vehicleObj,
        ...ownerObj,
      });
    } else {
      form.setFieldsValue({
        location: (sessionStorage.getItem("currentLocationId") || "").includes(",")
          ? null
          : +sessionStorage.getItem("currentLocationId"),
      });
    }
  }, [lead, mode]); // Removed leadSources to prevent form reset when API loads

  // Separate useEffect to set opportunitySourceId when leadSources loads
  useEffect(() => {
    if (mode === "EDIT" && leadSources.length > 0 && lead?.opportunitySourceId && form) {
      form.setFieldsValue({
        opportunitySourceId: getParentIds(leadSources, +lead.opportunitySourceId),
      });
    }
  }, [leadSources, lead?.opportunitySourceId, mode, form]);

  const canAddEditOpportunity = checkAccessPermission(
    AccessPermissionAction.LEAD_OPPORTUNITY_MANAGEMENT_ADD_EDIT
  );

  /**
   * Persist a single vehicle immediately when editing an EXISTING opportunity.
   * Returns:
   *   { deferred: true } - no opportunity to attach to yet (new-opportunity
   *                        flow / ids unresolved) -> caller keeps it local.
   *   { saved: <vehicle> } - persisted; caller merges the returned id + refetches.
   *   { error: true } - mutation failed; caller keeps the drawer open.
   */
  const persistVehicle = async vehicle => {
    const opportunityId = mode === "EDIT" && !newOpportunity ? selectedOpportunity?.id : null;
    const resolvedLeadId =
      selectedOpportunity?.lead?.id ||
      selectedOpportunity?.leadId ||
      (selectedOpportunity?.vehiclesOfInterest || []).find(v => v?.leadId)?.leadId;

    // Updating an existing vehicle only needs the vehicle id; creating a new one
    // also needs the lead id. If we can't resolve what we need, defer to the
    // opportunity-level save (unchanged behavior).
    if (!opportunityId) return { deferred: true };
    if (!vehicle.id && !resolvedLeadId) return { deferred: true };

    const voiObject = toMutationInput(vehicle);
    try {
      if (vehicle.id) {
        const res = await updateLeadVehicleOfInterest({
          variables: { id: +vehicle.id, voiObject },
        });
        const out = res?.data?.updateLeadVehicleOfInterest;
        if (out?.statusCode === 200) {
          message.success(out?.message || "Vehicle saved");
          onVehiclePersisted();
          return { saved: out.leadVehicleOfInterest };
        }
        message.error(out?.message || "Failed to save vehicle");
        return { error: true };
      }
      const res = await createLeadVehicleOfInterest({
        variables: { leadId: +resolvedLeadId, leadOpportunityId: +opportunityId, voiObject },
      });
      const out = res?.data?.createLeadVehicleOfInterest;
      if (out?.statusCode === 200) {
        message.success(out?.message || "Vehicle added");
        onVehiclePersisted();
        return { saved: out.leadVehicleOfInterest };
      }
      message.error(out?.message || "Failed to add vehicle");
      return { error: true };
    } catch (e) {
      message.error("Failed to save vehicle");
      return { error: true };
    }
  };

  return (
    <div>
      <Form form={form} layout="vertical" onFinish={handleSave}>
        <LeadOpportunityInformationForm
          mode={mode}
          leadData={leadData}
          setleadData={setleadData}
          form={form}
          lead={lead}
          selectedOpportunity={selectedOpportunity}
          setselectedOpportunity={setselectedOpportunity}
          newOpportunity={newOpportunity}
          setnewOpportunity={setnewOpportunity}
          showOpportunityDropdown={false}
          defaultOpportunity={lead}
          loader={updateLeadOpportunityLoader || createLeadOpportunityLoader}
          leadSources={leadSources}
          leadSourcesLoader={leadSourcesLoader}
          canAddEditOpportunity={canAddEditOpportunity}
          showCancel={showCancel}
          close={close}
          settingsProp={settingsProp}
          persistVehicle={persistVehicle}
          refetchOpportunity={() => {
            refetch();
            refetchLeads();
            getLeads();
          }}
          selectedOppTypeId={selectedOppTypeId}
        />
      </Form>
      {/* {mode === "ADD" && (
        <div className="bg-grey-200 p-4 flex flex-row gap-1 justify-start">
          <Button
            onClick={() => form.submit()}
            loading={createLeadOpportunityLoader}
            type="primary"
          >
            {mode === "EDIT" ? "Update Opportunity" : "Add Opportunity"}
          </Button>
          <Button onClick={close}>Cancel</Button>
        </div>
      )} */}
    </div>
  );
}
